// src/resources/bookings/components/BookingFilters.tsx
import { Filter, SearchInput, SelectInput } from "react-admin";

interface BookingFiltersProps {
  [key: string]: unknown;
}

export const BookingFilters = (props: BookingFiltersProps) => (
  <Filter {...props}>
    <SearchInput
      source="search"
      placeholder="Search by booking ID or provider order ID"
      alwaysOn
    />
    <SelectInput
      source="status"
      choices={[
        { id: "created", name: "Created" },
        { id: "awaiting_payment", name: "Awaiting Payment" },
        { id: "payment_received", name: "Payment Received" },
        { id: "started", name: "Started" },
        { id: "confirmed", name: "Confirmed" },
        { id: "failed", name: "Failed" },
        { id: "cancelled", name: "Cancelled" },
        { id: "payment_failed", name: "Payment Failed" },
      ]}
      alwaysOn
    />
  </Filter>
);
